import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoDuoRightLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/photoDuoRight" */ './PhotoDuoRight'), 'PhotoDuoRightLayout');
